import React from 'react';
import '../../styles/convokeDialogPatterns.scss';

const ConvokeDialogMessage = ({
  message,
  tone = 'neutral',
}) => {
  if (!message) return null;
  const isError = tone === 'error';
  return (
    <p
      className={`convoke-dialog-message${
        isError ? ' convoke-dialog-message--error' : ''
      }`}
      role={isError ? 'alert' : 'status'}
    >
      {message}
    </p>
  );
};

export default ConvokeDialogMessage;
